import React from 'react'
import Switch from 'react-router-dom/Switch';
import Route from 'react-router-dom/Route';
import Redirect from 'react-router-dom/Redirect';
import Login from './Login/Login';
import { hasRight } from './Login/Acl';
import Dashboard from './Screens/Dashboard/Dashboard';
import ViewPerson from './Screens/People/ViewPerson';
import TreeView from './Screens/People/TreeView';
import ViewPayment from './Screens/Payment/ViewPayment';
import ViewInvestorPay from './Screens/Payment/ViewInvestorPay';

// The Main component renders one of the three provided
// Routes (provided that one matches). Both the /roster
// and /schedule routes will match any pathname that starts
// with /roster or /schedule. The / route will only match
// when the pathname is exactly the string "/"
function Routes() {
  return (
    <Switch>
      <Route exact path='/' component={Login} />
      
      <SecuredRoute exact path="/viewPeople" Component={ViewPerson} />
      <SecuredRoute exact path="/Dash" Component={Dashboard} />
      <SecuredRoute exact path="/TreeView" Component={TreeView} />
      <SecuredRoute exact path="/Payment" Component={ViewPayment} />
      <SecuredRoute exact path="/VwInvestPay" Component={ViewInvestorPay} />
      
      <Redirect to="/" />
    </Switch>
  )
}
export default Routes;


const SecuredRoute = ({ path, Component }) => (
  <Route path={path} render={() => (
    hasRight(path)
      ? <Component />
      : <Redirect to="/" />
  )} />
)